export default __webpack_public_path__ + "atomic/_patterns/01-atoms/block-title/_block-title.twig";